import { DatePipe, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
//import { EvalGoalInterface } from '@tech-interfaces/eval-goal.interface';
import {
  EvalGoalInterface,
  SimulationObjInterface,
} from '@techrules/portallib';
import { CommonService } from '@tech-services/common.service';
import { InitcontributionService } from '@tech-services/initcontribution.service';
import { SessionService } from '@tech-services/session.service';
import { pipe, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppConfig } from '@tech-utils/app-config.service';
import { ModalriskwarningComponent } from './modalriskwarning/modalriskwarning.component';
import { FormatsService } from '@techrules/pipelib';
import { TechDialogsService } from '../../../shared/tech-dialogs.service';

@Component({
  selector: 'tech-initialcontribution',
  templateUrl: './initialcontribution.component.html',
  styleUrls: ['./initialcontribution.component.scss'],
})
export class InitialcontributionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  private simulationObj: SimulationObjInterface =
    this.initcontributionService.simulationObjSource.getValue();
  public form: UntypedFormGroup;
  public errorMinimun: boolean = true;

  constructor(
    private fb: UntypedFormBuilder,
    private commonService: CommonService,
    private initcontributionService: InitcontributionService,
    private datePipe: DatePipe,
    private sessionService: SessionService,
    private translate: TranslateService,
    private dialogService: TechDialogsService,
    public dialog: MatDialog,
    private formatsService: FormatsService,
    @Inject(DOCUMENT) private document: any
  ) {
    this.newform();
  }

  ngOnInit() {
    document.querySelector('body').scrollTop = 0;
    this.translate.get('k002278').subscribe((text: string) => {
      // Token: Initial contribution
      this.commonService.setTitle(text + ' | ' + AppConfig.settings.tabTitle);
    });
    this.commonService.showMenuSource.next(false);
    this.commonService.loading$.next(true);
    this.initcontributionService
      .getFinancialPlanRefData()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.initcontributionService.fpReferenceDataSource.next(data);
        this.commonService
          .getClientData()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((res: any) => {
            this.loadSimulationObj();
            this.initcontributionService.simulationObj$
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((resp: SimulationObjInterface) => {
                this.initcontributionService
                  .getEvalGoal(resp)
                  .pipe(takeUntil(this.unsubscribe$))
                  .subscribe((respEval: EvalGoalInterface) => {
                    setTimeout(() => {
                      this.initcontributionService.evalGoalObjSource.next(
                        respEval
                      );
                    });
                  });
              });
          });
      });
    this.initcontributionService.agreeRiskWarning$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        if (data) this.sendInitialContribution();
      });

    this.initcontributionService.errorMinimun$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.errorMinimun = data;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public newform() {
    this.form = this.fb.group({
      simulationData: this.fb.group({
        issuingBank: ['', [Validators.required]],
        inicialAmount: ['', [Validators.required]],
        investCurrency: ['', [Validators.required]],
      }),
    });
  }

  public loadSimulationObj() {
    this.simulationObj.Currency =
      this.initcontributionService.fpReferenceDataSource.getValue().BaseCurrency;
    this.simulationObj.GoalAmount = 0;
    // this.simulationObj.Inflation = 0;
    if (localStorage.getItem('SimulationObj') != null) {
      this.simulationObj.InitialContributionAmount = Number(
        JSON.parse(localStorage.getItem('SimulationObj'))
          .InitialContributionAmount
      );
    } else {
      this.simulationObj.InitialContributionAmount = 0;
    }
    let now = new Date();
    this.simulationObj.InitialDate = this.datePipe.transform(
      now.setDate(now.getDate() - 1),
      'yyyy-MM-dd'
    );
    this.simulationObj.PeriodicContributionAmount = 0;
    this.simulationObj.PeriodicContributionFrequency = 'M';
    this.simulationObj.Priority = 0;
    this.simulationObj.ProfileId =
      this.initcontributionService.fpReferenceDataSource.getValue().ProfileId;
    this.simulationObj.Taxes = 0;
    this.simulationObj.TimeHorizon =
      this.initcontributionService.fpReferenceDataSource.getValue().GrowDefaultYears;
    this.simulationObj.Type = 'SAVING';
    this.simulationObj.Name = 'Increase my wealth';
    this.initcontributionService.simulationObjSource.next(this.simulationObj);
  }

  private sendInitialContribution() {
    this.commonService.loading$.emit(true);
    this.initcontributionService
      .saveGoal(this.simulationObj)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.initcontributionService
          .saveGoalPortfolio(data.Id)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((res) => {
            this.initcontributionService
              .funding(
                this.form.value.simulationData.issuingBank,
                this.form.value.simulationData.investCurrency
              )
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((result) => {
                localStorage.removeItem('SimulationObj');
                localStorage.removeItem('TargetSelect');
                localStorage.removeItem('FpReferenceData');
                this.document.location.href =
                  AppConfig.settings.base + '/completedata';
              });
          });
      });
  }

  public goNext() {
    if (this.simulationObj.InitialContributionAmount <= 0) {
      let text1: string;
      let text2: string;
      this.translate.get('k002278').subscribe((text: string) => {
        // Token: Initial contribution
        text1 = text;
      });
      this.translate.get('k002279').subscribe((text: string) => {
        text2 = text; //Token: You cannot continue without an initial contribution. You need it for opening an account.
        this.dialogService.openModalDialog('', text1, text2, '');
      });
    } else if (
      this.simulationObj.ProfileId >
      this.initcontributionService.fpReferenceDataSource.getValue().ProfileId
    ) {
      this.dialog.open(ModalriskwarningComponent, {
        panelClass: ['col-xs-12', 'col-sm-6', 'col-md-6', 'col-lg-6'],
        maxWidth: '100vw',
      });
    } else {
      this.sendInitialContribution();
    }
  }
}
